module.exports = __webpack_public_path__ + "img/2022-18.86fa85f2.jpg";